/* ------------------------------------------------------------
 * DAWTOX - cartes de lots : le prix par jour suit l'abonnement
 *
 * Le theme imprime le prix par jour tel qu'il est tape dans le
 * reglage de la carte, donc figé sur le tarif sans abonnement.
 * Des que le client bascule le selecteur, le prix total change
 * mais la mention par jour ne bouge pas. Ce fichier la recalcule.
 *
 * ------------------------------------------------------------
 * CE QU'IL NE FAUT PAS REFAIRE ICI, ET POURQUOI
 *
 * Une version precedente reecrivait aussi le prix barre des
 * cartes, pour ancrer sur la valeur des flacons recus plutot que
 * sur celle des flacons factures. Ca ne peut pas marcher :
 * <quantity-break-item> surveille son propre sous-arbre, et la
 * moindre ecriture dans sa zone de prix declenche un rendu
 * complet qui restaure sa valeur. Mesure le 1er septembre 2026 :
 * une seule ecriture produisait 61 mutations, et la reecriture
 * revenait en 250 ms. Avec la relance toutes les 300 ms, les
 * deux valeurs alternaient 48 fois sur 9 secondes, sous les yeux
 * du client. Le prix barre ne se corrige pas d'ici : il se
 * corrige dans le Liquid du theme, ou pas du tout.
 *
 * La mention par jour, elle, vit dans le richtext de la
 * description, que le theme ne recalcule jamais. C'est la seule
 * zone de la carte ou une ecriture tient.
 * ------------------------------------------------------------ */

(function () {
  "use strict";

  var argent = function (centimes) {
    return "$" + (centimes / 100).toFixed(2);
  };

  /* La derniere ligne de la description porte la duree : "60 days · $1.17/day".
     On garde le gabarit d'origine en dataset, sinon chaque passage
     remplacerait le montant deja remplace. */
  var ecritPrixParJour = function (phrase, total, jours) {
    if (!phrase || !total || !jours) return;
    if (!phrase.dataset.dawtoxGabarit) phrase.dataset.dawtoxGabarit = phrase.innerHTML;
    var voulu = phrase.dataset.dawtoxGabarit.replace(/\$[\d.,]+/, argent(Math.round(total / jours)));
    if (phrase.innerHTML !== voulu) phrase.innerHTML = voulu;   // on n'ecrit que si ca change
  };

  /* ---------- Frequence de livraison, selon le lot choisi ----------
     Un lot de 20 jours se renouvelle toutes les 4 semaines, un lot de
     60 jours toutes les 8, un lot de 100 jours toutes les 12. Le reglage
     du bloc ne porte qu'une seule phrase, figee : on y remplace le nombre
     de semaines en fonction de la carte selectionnee.

     Contrairement aux cartes de lots, le composant d'abonnement ne
     restaure pas ce qu'on ecrit chez lui : verifie le 1er septembre 2026,
     l'ecriture tient et survit meme au changement de lot.

     ATTENTION : cet affichage doit rester aligne sur les plans Recharge.
     Tant qu'un seul plan existe (4 semaines), les deux autres lignes
     annoncent une frequence qui n'est pas encore vendue. */
  var SEMAINES_PAR_LOT = [4, 8, 12];   // rang de la carte -> semaines

  var lotSelectionne = function () {
    var cartes = document.querySelectorAll("quantity-break-item");
    for (var i = 0; i < cartes.length; i++) {
      if (cartes[i].classList.contains("quantity-break--selected")) return i;
    }
    return -1;
  };

  var ecritFrequence = function () {
    var rang = lotSelectionne();
    if (rang < 0) return;
    var semaines = SEMAINES_PAR_LOT[rang] || SEMAINES_PAR_LOT[SEMAINES_PAR_LOT.length - 1];

    /* La mention sous le bouton d'ajout, « Refills every N weeks », doit
       annoncer la meme cadence que la carte. Elle vit dans un bloc
       icon-with-text portant la classe dawtox-recharge. */
    var recharge = document.querySelector(".dawtox-recharge p, .dawtox-recharge .text-block p");
    if (recharge) {
      if (!recharge.dataset.dawtoxGabarit) recharge.dataset.dawtoxGabarit = recharge.innerHTML;
      var vouluR = recharge.dataset.dawtoxGabarit.replace(/\d+\s*weeks?/i, semaines + " weeks");
      if (recharge.innerHTML !== vouluR) recharge.innerHTML = vouluR;
    }

    var options = document.querySelectorAll(".dawtox-abo .subscription__option");
    for (var j = 0; j < options.length; j++) {
      var radio = options[j].querySelector('input[name="subscription_type"]');
      if (!radio || radio.value !== "subscription") continue;
      var phrase = options[j].querySelector(".subscription__option-description p");
      if (!phrase) return;
      if (!phrase.dataset.dawtoxGabarit) phrase.dataset.dawtoxGabarit = phrase.innerHTML;
      var voulu = phrase.dataset.dawtoxGabarit.replace(/\d+\s*weeks?/i, semaines + " weeks");
      if (phrase.innerHTML !== voulu) phrase.innerHTML = voulu;
      return;
    }
  };

  /* ---------- Le plan d'abonnement suit le lot choisi ----------
     Chaque variante lot a desormais son propre plan Recharge : 4 semaines
     pour le flacon seul, 8 pour le lot de 3, 12 pour le lot de 5. Mais le
     bloc d'abonnement du theme fige le plan au rendu et ne le change pas
     quand la carte de lot change de variante : il postait donc le plan du
     flacon seul sur un lot, et Shopify refusait l'ajout au panier.

     On lit la correspondance dans le JSON du produit, ou chaque variante
     porte son unique allocation, et on remet le bon identifiant dans le
     champ avant l'envoi. */
  var plansParVariante = null;

  var chargePlans = function () {
    if (plansParVariante || !document.querySelector("quantity-break-item")) return;
    plansParVariante = {};   // evite deux appels en vol
    /* Sur une page produit, le JSON est a l'adresse de la page. Sur la home,
       la section « produit en vedette » n'a pas cette adresse : on part du
       champ product-id de son formulaire et on retrouve le handle dans le
       catalogue public. Sans ca, la home postait le plan du flacon seul sur
       un lot et Shopify refusait l'ajout en abonnement (constate en ligne le
       22 septembre 2026). */
    var chemin = window.location.pathname.split("?")[0];
    var source;
    if (chemin.indexOf("/products/") !== -1) {
      source = fetch(chemin + ".js").then(function (r) { return r.ok ? r.json() : null; });
    } else {
      var champ = document.querySelector('form[action*="/cart/add"] input[name="product-id"]');
      var idProduit = champ && champ.value;
      source = !idProduit ? Promise.resolve(null)
        : fetch("/products.json?limit=250")
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (c) {
              var p = c && (c.products || []).filter(function (x) { return String(x.id) === String(idProduit); })[0];
              return p ? fetch("/products/" + p.handle + ".js").then(function (r) { return r.ok ? r.json() : null; }) : null;
            });
    }
    source
      .then(function (p) {
        if (!p || !p.variants) return;
        p.variants.forEach(function (v) {
          var a = v.selling_plan_allocations || [];
          if (a.length) plansParVariante[String(v.id)] = String(a[0].selling_plan_id);
        });
        maj();
      })
      .catch(function () {});
  };

  /* Chaque variante lot a son propre plan Recharge. Le bloc d'abonnement du
     theme, lui, fige un seul identifiant de plan au rendu et poste celui-la
     quel que soit le lot choisi : Shopify refuse alors l'ajout, le plan
     n'etant pas valable pour cette variante.

     On ne peut pas corriger avant l'envoi : le DOM ne porte pas la variante
     finale, toutes les cartes affichent celle du flacon seul et c'est le
     theme qui resout la bonne au moment de la requete. On corrige donc la
     requete elle-meme, seul endroit ou la variante est certaine. */
  var enveloppeAjoutPanier = function () {
    if (!window.fetch || window.fetch.__dawtox) return;
    var origine = window.fetch;
    var enveloppe = function (ressource, options) {
      try {
        var url = typeof ressource === "string" ? ressource : (ressource && ressource.url) || "";
        if (plansParVariante && options && options.body && url.indexOf("/cart/add") !== -1) {
          var charge = JSON.parse(options.body);
          var change = false;
          (charge.items || []).forEach(function (article) {
            var voulu = plansParVariante[String(article.id)];
            if (voulu && article.selling_plan && String(article.selling_plan) !== voulu) {
              article.selling_plan = voulu;
              change = true;
            }
          });
          if (change) options = Object.assign({}, options, { body: JSON.stringify(charge) });
        }
      } catch (e) { /* en cas de doute on laisse passer la requete d'origine */ }
      return origine.apply(this, [ressource, options]);
    };
    enveloppe.__dawtox = true;
    window.fetch = enveloppe;
  };

  var maj = function () {
    document.querySelectorAll("quantity-break-item").forEach(function (carte) {
      var phrases = carte.querySelectorAll(".quantity-break__description p");
      if (!phrases.length) return;

      var derniere = phrases[phrases.length - 1];
      var duree = (derniere.textContent || "").match(/(\d+)\s*days?/i);
      var jours = duree ? parseInt(duree[1], 10) : 0;
      var total = parseInt(carte.getAttribute("data-total-price"), 10) || 0;

      ecritPrixParJour(derniere, total, jours);
    });
    ecritFrequence();
  };

  var relance = function (delai) { setTimeout(maj, delai || 200); };

  /* Bascule du selecteur d'abonnement, et selection d'une autre carte. */
  document.addEventListener("change", function (e) {
    if (e.target && e.target.name === "subscription_type") relance(200);
  });
  document.addEventListener("click", function (e) {
    if (e.target && e.target.closest && e.target.closest("quantity-break-item, .achat-unique")) relance(220);
  });

  /* Quelques passages au chargement, le temps que le selecteur d'abonnement
     finisse de s'installer. Quatre suffisent : on ne se bat plus contre le
     theme, on ecrit dans la seule zone qu'il ne reprend pas. */
  chargePlans();
  enveloppeAjoutPanier();
  maj();
  /* Le theme arrete son choix de lot par defaut tard, apres l'hydratation du
     selecteur d'abonnement : sans passe tardive, la frequence affichee reste
     celle du premier lot alors qu'un autre est selectionne. */
  [300, 900, 2000, 3500, 6000].forEach(function (d) { setTimeout(maj, d); });
})();

/* ------------------------------------------------------------------
   Galerie des images produit : boucle continue.

   Woodson, 22 septembre 2026 : d'abord « quand on arrive a la derniere
   image, ca recommence a la premiere », puis « fluide, comme si on
   continuait de slider ». Le premier est le mode rewind de Splide (retour
   direct), le second son mode loop (les images se repetent en continu).
   Le theme monte la galerie en mode par defaut et ne permet pas d'en
   changer par un reglage ; un type de carrousel ne se change pas sur une
   instance montee. On demonte donc celle du theme et on la remonte en
   loop avec ses propres options, sans toucher a slider.js. La reference
   `el.slider` est remise a jour pour que le composant du theme continue
   de piloter la bonne instance.
   ------------------------------------------------------------------ */
(function () {
  var remonte = function (el) {
    var s = el.slider;
    if (!s || s.__dawtoxBoucle || !window.Splide) return false;
    var piste = el.querySelector('[data-ref="main-slider"]');
    if (!piste || el.thumbnailSlider) return false;   // avec vignettes on ne touche a rien
    // Les reglages de la galerie sont relus sur le composant : `s.options`
    // rend les valeurs par defaut de Splide apres un destroy, et la
    // galerie sortait avec des fleches et des points que le theme n'affiche
    // pas (Woodson : « enleve-moi ces fleches »).
    // Les options sont reconstruites comme dans slider.js du theme (les
    // relire sur `s.options` apres un destroy rend les valeurs par defaut
    // de Splide : fleches, points et ecart perdus). Ecart de 10 px entre les
    // images : Woodson, « juste un tout petit suffit ».
    var fleches = el.getAttribute("data-show-arrows") === "true";
    var points = el.getAttribute("data-show-pagination") === "true";
    var parPageBureau = parseInt(el.getAttribute("data-per-page-desktop"), 10) || 1;
    var options = {
      type: "loop", clones: 2, rewind: false, rewindByDrag: false,
      perPage: 1, perMove: 1, gap: "10px", drag: true,
      noDrag: ".before-after-block__slider, .before-after-block__slider *, model-viewer, model-viewer *",
      snap: true, arrows: fleches, pagination: points, autoplay: false,
      autoHeight: true, lazyLoad: false, flickMaxPages: 1, flickPower: 400, mediaQuery: "min",
      breakpoints: { 750: { perPage: parPageBureau, pagination: points, arrows: fleches } }
    };
    try {
      var index = s.index || 0;
      s.destroy(true);
      var neuf = new Splide(piste, options);
      neuf.__dawtoxBoucle = true;
      el.slider = neuf;
      neuf.on("mounted", function () { if (typeof el.updateSize === "function") el.updateSize(); });
      neuf.mount();
      if (index > 0) neuf.go(index);
      return true;
    } catch (e) { return false; }
  };
  var pose = function () {
    var ok = false;
    document.querySelectorAll("slider-component.product-media-gallery").forEach(function (el) { if (remonte(el)) ok = true; });
    return ok;
  };
  var essais = 0;
  var minuteur = setInterval(function () {
    essais += 1;
    if (pose() || essais > 40) clearInterval(minuteur);
  }, 250);
  var galerie = document.querySelector("product-media-gallery");
  if (galerie && window.MutationObserver) {
    new MutationObserver(function () { setTimeout(pose, 50); }).observe(galerie, { childList: true, subtree: false });
  }
})();
